import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "@/utils/axios";
import type {
  CreateCancelRequestPayload,
  ApproveCancelRequestPayload,
} from "./types";

export const useCreateCancelFormalityRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      formality_request_id,
      reason,
    }: CreateCancelRequestPayload) => {
      const response = await axios.post(
        `/admin/v1/formality-request/${formality_request_id}/cancellation-requests`,
        { reason },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["formaly-request"],
      });
      queryClient.invalidateQueries({
        queryKey: ["formaly-request"],
      });
    },
  });
};

export const useApproveCancelFormalityRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      cancellation_request_id,
      approved,
    }: ApproveCancelRequestPayload) => {
      const response = await axios.post(
        `/admin/v1/formality-request/cancellation-requests/${cancellation_request_id}/leader-approval`,
        { approved },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["formaly-request"],
      });
      queryClient.invalidateQueries({
        queryKey: ["formaly-request"],
      });
    },
  });
};
